import React from "react";
import "./style.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
// import Form from "./Form"; // temporarily unused - bringing it back later
function GetTouch(props) {
  /** import the Form Component  | khaled Mofeed */
  return (
    <Row
      className="justify-content-center align-items-center min-height-100per Team GetTouch pt-0"
      id="ContactUs"
    >
      <Col md={10} xl={10} className="pt-0">
        {/* <Row className="align-items-center justify-content-center  GetInTouchTitle">
          <Col lg={10}>
            <h2>Let's Build What's Next</h2>
            <p>
              Whether you need digital innovation, business expertise, or
              trusted supply solutions, our team is ready to help. Email us at{" "}
              <a href="mailto:info@lozrian.com">info@lozrian.com</a> or reach
              out through the form below.
            </p>
          </Col>
        </Row> */}
        <Row className="align-items-center lozrian-world">
          <Col lg={5}>
            <Row className="justify-content-center align-items-center bg-border-gradiant contact-form-bg">
              <Col lg={12} xl={12}>
                {/* Form temporarily replaced with text - will bring it back later */}
                {/* <Form /> */}
                <div className="GetTouch-placeholder-text">
                  <h2>Let's Build What's Next</h2>
                  <p>
                    Whether you're looking for digital innovation, business
                    expertise, or reliable supply solutions, our team is
                    ready to support you.
                  </p>
                  <ul className="GetTouch-contact-list">
                    <li>
                      <span className="GetTouch-contact-label">
                        Digital Solutions Department
                      </span>
                      <a href="mailto:info@lozrian.com">info@lozrian.com</a>
                    </li>
                    <li>
                      <span className="GetTouch-contact-label">
                        Trading Department
                      </span>
                      <a href="mailto:KS@lozrian.com">KS@lozrian.com</a>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Col>

          <Col className="lozrian-world-text" lg={7}>
            <div className="rightImgMsg position-relative d-none d-lg-block">
              {/* <img
                src="/img/global1.png"
                alt="global1"
                className="big-circle"
              />
              <img
                src="/img/global2.png"
                alt="global2"
                className="small-circle"
              />
              <img
                src="/img/global-dot1.png"
                alt="global-dot1"
                className="dot"
              />
              <img
                src="/img/global-dot2.png"
                alt="global-dot2"
                className="dot2"
              /> */}
              {/* <img src="/img/map.png" alt="map" className="global" /> */}
              {/* <img
                src="/img/circleBG.svg"
                alt="circleBG"
                fluid
                className="circleBG"
              /> */}
              <img
                src="/img/Expertise/Shape2.png"
                alt="global2"
                className="small-circle"
              />
              <img
                src="/img/message.svg"
                alt="message"
                className="messageImg"
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default GetTouch;
